import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import {BuckupsModule} from './buckups-ang7/backups.component.module'
import { AboutModule } from './about/about.module';
import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';
import { CmsManagementModule } from './cms-management/cms-management.module';
import { EditModeModule } from './edit-mode/edit-mode.module';
import { EnvironmentDetailsModule } from './environmentDetails/environment-details.module';
import { MyProfileModule } from './my-profile/my-profile.module';
import { PolicyEngineModule } from './policyEngine/policy-engine.module';
import { HtmlPageModule } from './files/html-page/html-page.module';
import { UserManagementModule } from './usersRolesManagement/usersManagement/usersManagement-module';
import { PipelineModule } from './project/pipeline/pipeline.module';
import { SideMenuModule } from './side-menu/side-menu.module';
import { TaskManagerModule } from './project/taskManager-ang7/taskManager.moudle';
import {LogViewerModule} from './log-viewer-ang7/log-viewer.component.module'
import { SubMenuModule } from './sub-menu/sub-menu.module';
import { TagTypesManagerModule } from './tag-types-manager/tag-types-manager.module';
import { TopBarModule } from './top-bar/top-bar.module';
import {ConfigurationsViewModule} from './project/configurationsView-ang7/configurationsView.module'
import { PackageManagerModule } from './project/packageManager/package-manager.module';
import {HooksModule} from './project/hooks-ang7/hooks.component.module';
import { UsersRolesManagementModule } from './usersRolesManagement/userRolesManagement.module';
import {JiraCmsManagerModule} from './project/jiraCMSManager-ang7/jira-cms-manager.moudle';
import { OidcModule } from './usersRolesManagement/advancedManagement/oidc-configuration/oidc.module';
import { DomainManagerModule } from './usersRolesManagement/advancedManagement/domain-manager/domain-manager.module';
import { ProjectGroupsModule } from './usersRolesManagement/advancedManagement/project-groups/project-groups.module';
import { ProjectManagementModule } from './usersRolesManagement/project-management/project-management.module';
import {AdvancedManagementModule} from './usersRolesManagement/advancedManagement/advancedManagement.module'
import { RolesManagementModule } from './usersRolesManagement/roles-management/roles-management.module';
import { UsersModule } from './usersRolesManagement/usersManagement/users/users.module';
import { UserGroupsModule } from './usersRolesManagement/usersManagement/users-groups/users-groups.module';
import { AdminModule } from '@app/authorized/admin/admin.module';
import { ExcludeObjectModule } from '@app/authorized/project/exclude-objects/exclude-object.module';
import { StaticContentModule} from '@app/authorized/project/static-content/static-content.module';
import {ImpactAnalysisPolicyModule} from '@app/authorized/project/impact-analysis/impact-analysis-policy-ang7/impact-analysis-policy.module'
import {ImpactAnalysisChangesModule} from '@app/authorized/project/impact-analysis/impact-analysis-changes-ang7/impact-analysis-changes.module'
import { VariablesModule } from '@app/authorized/project/variables/variables.module';
import { ProjectWizardModule } from '@app/authorized/projectWizard/project-wizard.module';
import {ImpactAnalysisScopesModule} from '@app/authorized/project/impact-analysis/impact-analysis-scopes-ang7/impact-analysis-scopes.module'
import { VaultManagementModule } from '@app/authorized/vault-management/vault-management.module';
import { ImpactAnalysisModule } from './project/impact-analysis/impact-analysis.module';
import { LegendModule } from './project/pipeline/legend-ang7/legend.module';
//import {newDashboardModule} from './newDashBoard-ang7/newDashboard.module'
import {processesHoverViewModule} from './project/pipeline/processesHoverView-ang7/processesHoverView.module'
import { ImpactAnalysisPrecheckErrorsModule } from './project/impact-analysis/impact-analysis-precheck-errors-ang7/impact-analysis-precheck-errors.module';
import {DeployedPackagesDetailsModule} from '@app/authorized/reports/deployed-packages-details/deployed-packages-details.module'
import { RepoersAuditDetailsModule } from '@app/authorized/reports/report-details-an7/reports-audit.component.module'; 
import {ImpactAnalysisHeaderModule} from '@app/authorized/project/impact-analysis/impact-analysis-header-ang7/impact-analysis-header.module'
import {ImpactAnalysisDeploymentModule} from '@app/authorized/project/impact-analysis/impact-analysis-deployment-ang7/impact-analysis-deployment.module'
import { DbmComponentsModule } from '@app/shared/components/dbm-components/dbm-components.module';
//import { changeVolumeActions } from '@src/store/reducers/changeVolumeReducer';
import { ChatbotManagementComponent } from '@app/authorized/chatbot-management/chatbot-management.component';
import { ChatbotItemComponent } from '@app/authorized/chatbot-management/chatbot-item/chatbot-item.component';

@NgModule({
   entryComponents: [ChatbotManagementComponent],
   declarations: 
        [ChatbotManagementComponent, 
        ChatbotItemComponent],
    imports: [
        SharedModule,
        RepoersAuditDetailsModule,
        ImpactAnalysisHeaderModule,
        LegendModule,
        processesHoverViewModule,
        OidcModule,
        UserManagementModule,
        UsersRolesManagementModule,
        TaskManagerModule,
        AboutModule,
        ImpactAnalysisModule,
        AdvancedManagementModule,
        ConfigurationsViewModule,
        HooksModule,
        ImpactAnalysisScopesModule,
        LogViewerModule,
        ImpactAnalysisPrecheckErrorsModule,
        BreadcrumbsModule,
     //   newDashboardModule,
        ImpactAnalysisDeploymentModule,
        ExcludeObjectModule,
        StaticContentModule,
        ImpactAnalysisChangesModule,
        JiraCmsManagerModule,
        VariablesModule,
        CmsManagementModule,
        VaultManagementModule,
        AdminModule,
        EditModeModule,
        EnvironmentDetailsModule,
        MyProfileModule,
        BuckupsModule,
        ImpactAnalysisPolicyModule,
        PolicyEngineModule,
        HtmlPageModule,
        PipelineModule,
        SideMenuModule,
        SubMenuModule,
        TagTypesManagerModule,
        TopBarModule,
        ProjectWizardModule,
        DeployedPackagesDetailsModule,
        PackageManagerModule,
        DomainManagerModule,
        ProjectGroupsModule,
        ProjectManagementModule,
        RolesManagementModule,
        UsersModule,
        UserGroupsModule,
        DbmComponentsModule
    ]
})
export class AuthorizedModule {
    ChatbotManagementComponent   
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/authorized.module.ts